export const greenColor   = '#1b5e20';
export const redColor     = '#f34225';
export const yellowColor     = '#ffc107';
export const blueColor     = '#1738e4';
export const orangeColor     = '#ff9800';


export const passwordPrimary          = 'linear-gradient(60deg, #ef5350, #e53935)';
export const passwordPrimaryShadow    = 'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(244, 67, 54, 0.4) 0px 7px 10px -5px';
export const passwordSecondary        = '#ffeeed';
export const passwordMain             = '#e53935';


export const companyPrimary           = 'linear-gradient(60deg, rgb(38, 198, 218), rgb(0, 172, 193))';
export const companyPrimaryShadow     = 'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(0, 172, 193, 0.4) 0px 7px 10px -5px';
export const companySecondary         = '#f1fdff';
export const companyMain              = '#00acc1';


export const clientPrimary            = 'linear-gradient(60deg, rgb(102, 187, 106), rgb(67, 160, 71))';
export const clientPrimaryShadow      = 'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(76, 175, 80, 0.4) 0px 7px 10px -5px';
export const clientSecondary          = 'rgb(232, 245, 233)';
export const clientMain               = '#4aa34b';


export const employeePrimary          = 'linear-gradient(60deg, rgb(255, 167, 38), rgb(251, 140, 0))';
export const employeePrimaryShadow    = 'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(255, 152, 0, 0.4) 0px 7px 10px -5px';
export const employeeSecondary        = 'rgb(253, 246, 237)';
export const employeeMain             = '#f28f3d';


export const glAccountPrimary         =  'linear-gradient(60deg, rgb(156, 39, 176), rgb(103, 58, 183))';
export const glAccountPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(156, 39, 176) 0px 7px 10px -5px';
export const glAccountSecondary       =  '#f3e5f5';
export const glAccountMain            =  '#ac57bc';


export const settingsPrimary         =  'linear-gradient(60deg, rgb(48, 150, 243), rgb(2, 111, 193))';
export const settingsPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const settingsSecondary       =  'rgb(242, 247, 251)';
// export const settingsMain            =  '#026fc1';
export const settingsMain            =  '#0f1941';

export const payrollPrimary         =  'linear-gradient(60deg, rgba(65, 68, 70, 0.29), rgb(149, 153, 158))';
export const payrollPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const payrollSecondary       =  'rgb(216, 227, 234)';
export const payrollMain            =  'rgb(234, 73, 99)';


export const masterPrimary         =  'linear-gradient(60deg, rgba(246, 235, 230), rgb(174, 225, 249))';
export const masterPrimaryShadow   =  '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)';
export const masterSecondary       =  'rgba(245, 235, 230, 0.3)';
export const masterMain            =  'rgb(9, 169, 244)';
export const masterTextColor       =  'rgb(26, 102, 139)';

// brown shade
export const fbpPrimary         =  'linear-gradient(60deg, #a1887f, #8d6e63)';
export const fbpPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const fbpSecondary       =  '#d7ccc8';
export const fbpMain            =  '#a1887f';


export const costCentrePrimary         =  'linear-gradient(60deg, #35838f, #204b53)';
export const costCentrePrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const costCentreSecondary       =  '#eaf7f4';
export const costCentreMain            =  '#275e67';


export const recoStatusPrimary         =  'linear-gradient(60deg, #48819e, #30637d)';
export const recoStatusPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const recoStatusSecondary       =  '#f1faff';
export const recoStatusMain            =  '#30637d';

// cherry color
export const payrollComputePrimary         =  'linear-gradient(60deg, #d81b60, #e91e63)';
export const payrollComputePrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const payrollComputeSecondary       =  '#fce4ec';
export const payrollComputeMain            =  '#d81b60';

// teal color
export const reportsPrimary         =  'linear-gradient(60deg, #26a69a, #4db6ac)';
export const reportsPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const reportsSecondary       =  '#e0f2f1';
export const reportsMain            =  '#26a69a';


// light blue violet shade color
export const lightVioletPrimary         =  'linear-gradient(60deg, #8995b3, #939eba)';
export const lightVioletPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const lightVioletSecondary       =  '#d8deeb';
export const lightVioletMain            =  '#8995b3';


// lime shade color
export const limePrimary         =  'linear-gradient(60deg, #827717, #9e9d24)';
export const limePrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const limeSecondary       =  '#f0f4c3';
export const limeMain            =  '#827717';

// yellow
export const yellowPrimary         =  'linear-gradient(60deg, #edb94c, #f2b941)';
export const yellowPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const yellowSecondary       =  '#fbdb94';
export const yellowMain            =  '#fbc346';

//cyan
export const cyanPrimary         =  'linear-gradient(60deg, #00acc1, #0097a7)';
export const cyanPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const cyanSecondary       =  '#e0f7fa';
export const cyanMain            =  '#00acc1';


//deepBlue
export const deepBluePrimary         =  'linear-gradient(60deg, #01306b, #004091)';
export const deepBluePrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
// export const deepBlueSecondary       =  '#001229';
// export const deepBlueMain            =  '#01306b';
export const deepBlueSecondary       =  '#0e3461';
export const deepBlueMain            =  '#01306b';


//deepPurple
export const deepPurplePrimary         =  'linear-gradient(60deg, #7039d4, #673ab7)';
export const deepPurplePrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const deepPurpleSecondary       =  '#ede7f6';
export const deepPurpleMain            =  '#7039d4';

//black
export const blackPrimary         =  'linear-gradient(60deg, #1e1a21, #342e38)';
export const blackPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const blackSecondary       =  '#eaeaea';
export const blackMain            =  '#000000';

//lightgrey
export const lightGreyPrimary         =  'linear-gradient(60deg, #bfbfbf, #eaeaea)';
export const lightGreyPrimaryShadow   =  'rgba(0, 0, 0, 0.14) 0px 4px 20px 0px, rgba(71, 96, 188, 0.5) 0px 7px 10px -5px';
export const lightGreySecondary       =  '#f0f0f0';
export const lightGreyMain            =  '#bfbfbf';

